export default "__VITE_ASSET__BQUpmw77__"